import * as m from 'mithril';
import AppContext from '../context/AppContext';

import { SubFsm } from 'little-fsm';
import { TentativeBookingCreationFsmScheme } from '../states/tentative-booking/TentativeBookingCreationFsmScheme';
import TravellerFormPage from '../pages/travellerinfo/TravellerFormPage';
import { TravellerDTO } from '../apiclient/ApiDtos';
import { ApiService } from '../ApiService';
import { WayPointSelectionFsmContext } from '../states/pickup-dropoff-order/WayPointsSelectionFsmContext';

export function buildTentativeBookingCreationPresenter(
    appContext: AppContext,
    apiService: ApiService,
    subFsm: SubFsm<TentativeBookingCreationFsmScheme>): { render: () => m.Vnode } {


    subFsm.setEnterEffect('creating', c => {
        let travellerInfo = c.travellerInfo;
        let tripCustomizationId = c.tripCustomizationContext.tripCustomization!.id;
        apiService.createTentativeBooking(tripCustomizationId, travellerInfo).then(result => {
            console.log("Tentative Booking result", result);
            if (result.right) {
                subFsm.processEvent('created', { tentativeBooking: result.right })
            }
        });
    })

    return {
        render() {
            let context = subFsm.getCurrentContext();
            let substate = subFsm.getCurrentSubState();
            let backTo : 'WAYPOINT_SELECTION' | 'SEAT_SELECTION' | 'SEAT_AUTOASSIGNMENT_INFO'= 'SEAT_SELECTION';
            if (
                context.tripCustomizationContext instanceof WayPointSelectionFsmContext
                && context.tripCustomizationContext.hasPickUpDropOffOrder()
            ) {
                backTo = 'WAYPOINT_SELECTION';                
            }else if(!context.tripCustomizationContext.tripDetails!!.isSeatSelectionAllowed){
                backTo = 'SEAT_AUTOASSIGNMENT_INFO';
            }

            return m(TravellerFormPage, {
                appContext: appContext,
                messageProvider: appContext.getMessageProvider(),
                tripCustomization: context.tripCustomizationContext.tripCustomization!,
                isBacktracking: substate == 'back_navigation_confirming',
                backTrackingTo: backTo,
                isSubmitting: substate == 'creating',
                onBacktrack: () => {
                    subFsm.processEvent('back', {});
                },
                onBacktrackConfirmed: () => {
                    subFsm.processEvent('back_confirmed', {});
                },
                onBacktrackCancelled: () => {
                    subFsm.processEvent('back_cancelled', {});
                },
                onSubmit: (travellerInfo: TravellerDTO) => {
                    console.log("Traveller Form submit", travellerInfo);
                    subFsm.processEvent('create_requested', { travellerInfo: travellerInfo });
                },
            });
        }
    }
}